// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__3QU7D","step":"Card_step__gAvJj","text":"Card_text__2p2-i"};